import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="mt-8 space-y-4">
      {/* Security Notice */}
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-3" dir="rtl">
        <div className="flex items-start space-x-3 space-x-reverse">
          <Icon name="Shield" size={16} className="text-accent flex-shrink-0 mt-0.5" />
          <div className="text-right">
            <p className="text-xs text-accent font-medium">
              اتصال آمن ومشفر
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              جميع البيانات محمية بتشفير SSL
            </p>
          </div>
        </div>
      </div>

      {/* Support Information */}
      {/* <div className="text-center space-y-2">
        <p className="text-xs text-muted-foreground" dir="rtl">
          هل تواجه مشكلة في تسجيل الدخول؟
        </p>
        <div className="flex items-center justify-center space-x-4 space-x-reverse text-xs text-muted-foreground">
          <a 
            href="mailto:support@ssu.org" 
            className="flex items-center space-x-1 space-x-reverse hover:text-accent transition-colors"
          >
            <Icon name="Mail" size={12} />
            <span>support@ssu.org</span>
          </a>
          <span>•</span>
          <a 
            href="tel:+905551234567" 
            className="flex items-center space-x-1 space-x-reverse hover:text-accent transition-colors"
          >
            <Icon name="Phone" size={12} />
            <span>+90 555 123 4567</span>
          </a>
        </div>
      </div> */}

      {/* Copyright */}
      <div className="text-center pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground" dir="rtl">
          © {currentYear} الإتحاد العام لطلبة سوريا. جميع الحقوق محفوظة.
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          Syrian Student Union. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LoginFooter;